import { formatTime } from '../../components/helpers.js'
import { getMaintenanceNoteStatusColor } from './ServiceObjectMaintenanceNote.js'
import { axiosGet } from '../../axios/axios.js'

export function loadNotes (sourceProps) {
  const params = new URLSearchParams()
  params.append('id', sourceProps.id)

  return axiosGet({
    url: '/service/delta/journal/serviceobjectmaintenancenotes/getObjectNotes?' + params.toString(),
    onSuccess: (response) => {
      return response.data.result
    },
    onFailure: 'Ошибка загрузки'
  })
}
export const TABLE_COLUMNS_MOBILE = [
  {
    name: 'maintenanceNoteStatus',
    label: 'Статус',
    format: n => n ? n.name : '',
    align: 'left',
    field: 'maintenanceNoteStatus',
    sortable: false,
    classFn: n => 'text-white text-bold q-pl-xs q-mr-xs bg-' + getMaintenanceNoteStatusColor(n)
  },
  {
    name: 'maintenanceNoteType',
    label: 'Тип',
    format: n => n ? n.name : null,
    align: 'left',
    field: 'maintenanceNoteType',
    sortable: false
  },
  {
    name: 'description',
    label: 'Описание',
    align: 'left',
    field: 'description',
    sortable: false
  },
  {
    name: 'files',
    label: 'Фото',
    align: 'left',
    field: 'files',
    sortable: false,
    hasValue: files => files && files.length > 0
  },
  {
    name: 'lastOperationCommentText',
    label: 'Последний комментарий',
    align: 'left',
    field: 'lastOperationCommentText',
    sortable: false
  },
  {
    name: 'lastOperationFiles',
    label: 'Последнее фото',
    align: 'left',
    field: 'lastOperationFiles',
    sortable: false,
    hasValue: files => files && files.length > 0
  }
]

export const TABLE_COLUMNS = [
  {
    name: 'number',
    label: '№',
    align: 'left',
    field: 'number',
    defaultWidth: 32,
    sortable: true
  },
  {
    name: 'maintenanceNoteType',
    label: 'Тип замечания',
    align: 'left',
    field: 'maintenanceNoteType',
    sortable: true,
    format: r => r ? r.name : null,
    sort: (val1, val2) => {
      return val1 <= val2 ? -1 : 1
    }
  },
  {
    name: 'maintenanceNoteStatus',
    label: 'Статус',
    align: 'left',
    field: 'maintenanceNoteStatus',
    sortable: true,
    format: n => n ? n.name : null,
    sort: (val1, val2) => {
      return val1 <= val2 ? -1 : 1
    }
  },
  {
    name: 'description',
    label: 'Описание замечания',
    align: 'left',
    field: 'description',
    sortable: true,
    style: 'white-space: pre-line !important; word-break: break-all;',
    defaultWidth: 400
  },
  {
    name: 'lastOperationCommentText',
    label: 'Последний комментарий',
    align: 'left',
    field: 'lastOperationCommentText',
    sortable: true,
    style: 'white-space: pre-line !important; word-break: break-all;',
    defaultWidth: 400
  },
  {
    name: 'serviceObject',
    label: 'Объект обслуживания',
    align: 'left',
    field: 'serviceObject',
    sortable: true,
    columnFormat: 'object',
    sort: (val1, val2) => {
      return val1.serviceObject && val1.serviceObject.name <= val2.serviceObject && val2.serviceObject.name ? -1 : 1
    }
  },
  {
    name: 'serviceObjectType',
    label: 'Тип объекта обслуживания',
    align: 'left',
    field: 'serviceObjectType',
    sortable: true,
    format: r => r ? r.name : null
  },
  {
    name: 'createDateTime',
    label: 'Дата/время создания записи',
    align: 'left',
    field: 'createDateTime',
    sortable: true,
    format: formatTime
  },
  {
    name: 'lastStateDateTime',
    label: 'Дата/время установки текущего статуса',
    align: 'left',
    field: 'lastStateDateTime',
    sortable: true,
    format: formatTime
  },
  {
    name: 'lastOperationDateTime',
    label: 'Дата/время последней записи',
    align: 'left',
    field: 'lastOperationDateTime',
    sortable: true,
    format: formatTime
  },
  {
    name: 'authorFIO',
    label: 'Автор замечания',
    align: 'left',
    field: 'authorFIO',
    sortable: true
  },
  {
    name: 'recordSource',
    label: 'Тип источника записи',
    align: 'left',
    field: 'recordSource',
    sortable: true,
    format: r => r ? r.name : null,
    sort: (val1, val2) => {
      return val1 <= val2 ? -1 : 1
    }
  },
  {
    name: 'sourceObject',
    label: 'Источник записи',
    align: 'left',
    field: 'sourceObject',
    sortable: true
  }
]
